import { render, staticRenderFns } from "./textoypdf.vue?vue&type=template&id=71759af3&"
import script from "./textoypdf.vue?vue&type=script&lang=js&"
export * from "./textoypdf.vue?vue&type=script&lang=js&"
import style0 from "./textoypdf.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports